

function slickCarousel() {
  if (window.matchMedia('(min-width: 992px)').matches) {
    $(".explore-container .wrapper .overflow-scroll-mobile").not('.slick-initialized').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: false,
      arrows: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true,
      prevArrow: $(".explore-container .prev"),
      nextArrow: $(".explore-container .next"),
      appendDots: $(".explore-container .dots"),
     
  });
}

  $(".instagram-container .wrapper").not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      prevArrow: $(".instagram-container .prev"),
      nextArrow: $(".instagram-container .next"),
      appendDots: $(".instagram-container .dots"),
      responsive: [
          {
              breakpoint: 991,
              settings: {
                  centerMode: false,
                  variableWidth: true,
                  arrows: false,
              },
          },
      ],
  });
}


$(window).scroll(function () {
  const scrollDirection = this.oldScroll > this.scrollY;
  const scrollTop = $(window).scrollTop();
  this.oldScroll = this.scrollY;

    if(scrollTop > 500) { 
      if(scrollDirection == false) {
        navbarNotFixed0()
      } else {
        navbarFixed0();
      }
    }

    else if(scrollTop == 0)  {
      navbarFixed0();
      $(".ico_main_logo2").addClass("hide");
      $(".ico_main_logo").removeClass("hide");
    }
      
  if (!$("#mega-menu-full-dropdown").hasClass("active") && scrollTop > 0) {
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
      $(".ico_main_logo2").removeClass("hide");
      $(".navbar-fixed-top").removeClass("navbar--old-bg");
      $(".navbar-pagination").removeClass("navbar--old");
      $(".navbar-fixed-top").removeClass("bg-transparent");

  } else {
    navbarFixed0();
      if ($("#mega-menu-full-dropdown").hasClass("active")) {
        $(".navbar-fixed-top").removeClass("bg-transparent");
          $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
          $(".ico_main_logo2").addClass("hide");
          $(".ico_main_logo").removeClass("hide");
      } else {
       
          $(".navbar-fixed-top").removeClass("top-scroll--modify-scrolled");
        
      }
      $(".navbar-fixed-top").removeClass("scrolled");
      $(".navbar-fixed-top").addClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("navbar--old-bg");
      $(".navbar-pagination").addClass("navbar--old");
      $(".navbar-fixed-top").addClass("bg-transparent");
    
  }

  bgTransparentContainer()
});


function navbarFixed0() {
  $('.navbar-fixed-top').css('position', 'fixed');
  $('.navbar-fixed-top').css('top', 0);
}
function navbarNotFixed0() {
  $('.navbar-fixed-top').css('position', 'fixed');
  $('.navbar-fixed-top').css('top', '-100%');
}

$(document).on("click", ".arrow-container", function () {
  if (window.innerWidth <= 991) {
      var ID = $(this).attr("id");
      
      if ($(this).hasClass("active")) {
          $(this).removeClass("active");
      } else {
          $(this).addClass("active");
      }
      $("." + ID).slideToggle("active");
  }
});

// $(".change-icon").mouseover(function () {
//   $(".icon_logo").removeClass("active");
//   var ID = $(this).attr("id");
//   $("." + ID).addClass("active");
// });

// $(".change-icon").mouseleave(function () {
//   $(".icon_logo").removeClass("active");
//   $(".main__ico").addClass("active");
// });

$(".explore-container .carousel-container").mouseover(function () {
  $(".explore-container .arrow-dots_container").addClass("hover-arrow");
});

$(".explore-container .carousel-container").mouseleave(function () {
  $(".explore-container .arrow-dots_container").removeClass("hover-arrow");
});

$(".burger-ico").click(function () {
  openMenu();
  navbarFixed0();
  bgTransparentContainer();
  $(".ico_main_logo").addClass("hide");
  $(".navbar-pagination").removeClass("modify-top--relative");
});

$(".x-ico").click(function () {
  navbarFixed0();
  bgTransparentContainer();
  $(".navbar-fixed-top").removeClass("navbar-position");
  $("#text-search").val("");
  $(".panel-menu--search").removeClass("active");
  $(".panel-menu--list").addClass("active");
  $(".ico_main_logo2").removeClass("hide");
  $("#mega-menu-full-dropdown").slideToggle(500);
  $(".toggle-button-burger .burger-ico").addClass("active");
  $(".toggle-button-burger .x-ico").removeClass("active");
  $("body").removeClass("overflow-none");
  $(".search-input--container").removeClass("active");
  $(".icon-container--search").addClass("active");
  $(".navbar-fixed-top").addClass("navbar--old-bg");
  $(".navbar-pagination").addClass("navbar--old");
  $("#mega-menu-full-dropdown").removeClass("active");
  $(".navbar-pagination").removeClass("modify-top--relative");
  const scrollTop = $(window).scrollTop();
  if (scrollTop === 0) {
      $(".navbar-fixed-top").addClass("navbar--old-bg");
      $(".navbar-pagination").addClass("navbar--old");
      $(".navbar-fixed-top").addClass("top-scroll--modify");
      $(".navbar-fixed-top").removeClass("scrolled");
      $(".ico_main_logo").removeClass("hide");
      $(".navbar-fixed-top").removeClass("top-scroll--modify-scrolled");
  } else {
      $(".navbar-fixed-top").removeClass("navbar--old-bg");
      $(".navbar-pagination").removeClass("navbar--old");
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
  }
});

$(".search--icon").click(function () {
  $("#text-search").val("");
  bgTransparentContainer();
  navbarFixed0();
  searchBarContainer();
});

function openMenu() {
  $(".navbar-fixed-top").removeClass("bg-transparent");
  $(".navbar-fixed-top").addClass("navbar-position");
  $("#text-search").val("");
  $(".panel-menu--search").removeClass("active");
  $(".panel-menu--list").addClass("active");
  $(".ico_main_logo2").addClass("hide");
  $(".search-input--container").removeClass("active");
  $(".icon-container--search").addClass("active");
  if (!$("#mega-menu-full-dropdown").hasClass("active")) {
      $("#mega-menu-full-dropdown").slideDown("slow");
      $("#mega-menu-full-dropdown").addClass("active");
  }

  $(".toggle-button-burger .burger-ico").removeClass("active");
  $(".toggle-button-burger .x-ico").addClass("active");
  $("body").addClass("overflow-none");

  const scrollTop = $(window).scrollTop();
  $(".navbar-fixed-top").removeClass("navbar--old-bg");
  $(".navbar-pagination").removeClass("navbar--old");
  if (scrollTop === 0) {
      $(".navbar-fixed-top").addClass("top-scroll--modify");
      $(".navbar-fixed-top").removeClass("scrolled");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
  } else {
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
  }
}

function searchBarContainer() {
  $(".navbar-fixed-top").removeClass("navbar--old-bg");
  $(".navbar-pagination").removeClass("navbar--old");
  const scrollTop = $(window).scrollTop();
  $(".toggle-button-burger .burger-ico").addClass("active");
  $(".toggle-button-burger .x-ico").removeClass("active");
  $(".navbar-fixed-top").removeClass("navbar--old-bg");
  $(".navbar-pagination").removeClass("navbar--old");

  if ($("#mega-menu-full-dropdown").hasClass("active")) {
      $("#mega-menu-full-dropdown").slideToggle("slow");
      $("#mega-menu-full-dropdown").removeClass("active");
      $("body").removeClass("overflow-none");
  }

  if ($(".panel-menu--list").hasClass("active") || $(".panel-menu--search").hasClass("active")) {
      $(".search-input--container").addClass("active");
      $(".icon-container--search").removeClass("active");
  } else {
      $(".search-input--container").removeClass("active");
      $(".icon-container--search").addClass("active");
  }

  if (scrollTop === 0) {
      $(".navbar-fixed-top").addClass("top-scroll--modify");
      $(".navbar-fixed-top").removeClass("scrolled");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
      $(".navbar-fixed-top").addClass("bg-transparent");
      $(".navbar-fixed-top").addClass("navbar--old-bg");
      $(".navbar-pagination").addClass("navbar--old");
  } else {
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
      $(".navbar-fixed-top").removeClass("bg-transparent");
  }

  $(".navbar-pagination").addClass("modify-top--relative");
  $(".left-icon--container").addClass("mobile-active");
  $(".logo-container").addClass("mobile-active");
  $("#mega-menu-full").addClass("mobile-active");
  $(".search-input--container").addClass("mobile-active");

  if ($(".navbar-fixed-top").hasClass("bg-transparent")) {
    $(".ico_main_logo2").addClass("hide");
    $(".ico_main_logo").removeClass("hide");
  } 
  else {
    $(".ico_main_logo").addClass("hide");
    $(".ico_main_logo2").removeClass("hide");
  }
}

$(".x-ico--input").click(function () {
  navbarFixed0();
  bgTransparentContainer();
  const scrollTop = $(window).scrollTop();
  searchContainerClose();
  searchContainerCloseMenuNav();
  $(".navbar-fixed-top").removeClass("bg-transparent");
  $(".ico_main_logo").removeClass("hide");
  $(".navbar-pagination").removeClass("modify-top--relative");
  if (scrollTop === 0) {
      $(".ico_main_logo").removeClass("hide");
  }
});

function searchContainerClose() {
  $(".toggle-button-burger .burger-ico").addClass("active");
  $(".toggle-button-burger .x-ico").removeClass("active");
  $(".left-icon--container").removeClass("mobile-active");
  $(".logo-container").removeClass("mobile-active");
  $("#mega-menu-full").removeClass("mobile-active");
  if ($("#mega-menu-full-dropdown").hasClass("active")) {
      $("#mega-menu-full-dropdown").slideToggle("slow");
      $("#mega-menu-full-dropdown").removeClass("active");
      $("body").removeClass("overflow-none");
  }

 
}

function searchContainerCloseMenuNav() {
  $(".icon-container--search").addClass("active");
  $("#text-search").val("");
  $(".search-input--container").removeClass("active");
  $(".search-input--container").removeClass("mobile-active");
  const scrollTop = $(window).scrollTop();
  if (scrollTop === 0) {
    $(".navbar-fixed-top").addClass("navbar--old-bg");
    $(".navbar-pagination").addClass("navbar--old");
    $(".navbar-fixed-top").addClass("top-scroll--modify");
    $(".navbar-fixed-top").removeClass("scrolled");
    $(".navbar-fixed-top").removeClass("top-scroll--modify-scrolled");
  } else {
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
      $(".ico_main_logo2").removeClass("hide");
  }
}
function bgTransparentContainer() {
  const scrollTop = $(window).scrollTop(); 
  if (scrollTop === 0 && !$("#mega-menu-full-dropdown").hasClass("active"))  {
    $(".navbar-fixed-top").addClass("bg-transparent");
    $('.navbar-pagination').css('top', '0 !important');
    $(".navbar-fixed-top").addClass("navbar--old-bg");
      $(".navbar-pagination").addClass("navbar--old");
  }
  else if($("#mega-menu-full-dropdown").hasClass("active")) {
    $(".navbar-fixed-top").removeClass("bg-transparent");
    $('.navbar-pagination').css('top', '-23px !important');
    $(".ico_main_logo2").addClass("hide");
    $(".ico_main_logo").addClass("hide");
  }
  else {
    $(".navbar-fixed-top").removeClass("bg-transparent");
   

  }
}
function searchContainerOpen() {
  $("body").addClass("overflow-none");
  $(".ico_main_logo2").addClass("hide");
  $(".panel-menu--search").addClass("active");
  $(".panel-menu--list").removeClass("active");
  $(".navbar-fixed-top").removeClass("bg-transparent");
  const scrollTop = $(window).scrollTop();
  if (scrollTop === 0) {
      $(".navbar-fixed-top").removeClass("navbar--old-bg");
      $(".navbar-pagination").removeClass("navbar--old");
      $(".navbar-fixed-top").addClass("top-scroll--modify");
      $(".navbar-fixed-top").removeClass("scrolled");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
  } else {
      $(".navbar-fixed-top").addClass("scrolled");
      $(".navbar-fixed-top").removeClass("top-scroll--modify");
      $(".navbar-fixed-top").addClass("top-scroll--modify-scrolled");
  }

  if (!$("#mega-menu-full-dropdown").hasClass("active")) {
      $("#mega-menu-full-dropdown").slideToggle("slow");
      $("#mega-menu-full-dropdown").addClass("active");
  }
}

/** Search Function - Eleixeis Burce */
$("#text-search").on("keypress", function () {
  getSearchData();
  searchContainerOpen();
});
$("#text-search").on("change", function () {
  getSearchData();
  searchContainerOpen();
});
$("#text-search").on("keydown", function () {
  getSearchData();
  searchContainerOpen();
});

function getSearchData() {
  $(".ico_main_logo").addClass("hide");
  $(".navbar-fixed-top").removeClass("bg-transparent");
  $(".navbar-pagination").removeClass("modify-top--relative");
  setTimeout(function () {
      var protocol = $(location).attr("protocol");
      var host = $(location).attr("hostname");
      var searchTerm = $("#text-search").val();
      var apiURL = "/wp-json/search-portal/v1/custom/";

      if( searchTerm.length >= 3 ) {
          $(".text-been-search").html("").html(searchTerm);
          searchTerm = encodeURIComponent(searchTerm);
          searchTerm = searchTerm.replace("%E2%80%99", "xsinglequotex");
          searchTerm = searchTerm.replace("'", "xsinglequotex");
          searchTerm = searchTerm.replace("%26", "xampersandx");
          var mainURL = protocol + "//" + host + apiURL + searchTerm;
          $.get(mainURL, function (response) {
              processResults("#food-drink-more-suggestion-list", "#food-drinks-container", response?.fooddrink?.contents, searchTerm);
              processResults("#things-to-do-more-suggestion-list", "#things-to-do-container", response?.thingstodo?.contents, searchTerm);
              processResults("#shops-more-suggestion-list", "#shops-container", response?.shops?.contents, searchTerm);
              processResults("#events-more-suggestion-list", "#events-container", response?.events?.contents, searchTerm);
              processResults("#page-more-suggestion-list", "#page-container", response?.page?.contents, searchTerm);
              processResults("#list-top-suggestion", "#list-container", response?.suggestion?.contents, searchTerm);
              processResults("#stories-more-suggestion-list", "#stories-container", response?.stories?.contents, searchTerm);
              processResults("#experiences-more-suggestion-list", "#experiences-container", response?.experiences?.contents, searchTerm);
          });
      }
  }, 500);
}

function processResults(domID, domContainer, domContents, searchTerm) {
  var p = $(domID);
  var c = $(domContainer);
  p.html("");
  if (!domContents.length) {
      p.addClass("d-none");
      c.addClass("d-none");
      return;
  } else {
      p.removeClass("d-none");
      c.removeClass("d-none");
  }
  searchTerm = decodeURIComponent(searchTerm);
  $.each(domContents, function (k, v) {
      var post_title = v.title.toLowerCase();
      var searchFor = post_title.replace(searchTerm.trim().toLowerCase(), "<strong>" + searchTerm.trim().toLowerCase() + "</strong>");
      p.append('<li style="text-transform: capitalize;"><a href="' + v.permalink + '" class="text-white">' + searchFor + "</a></li>");
  });
}

function igresize() {
  $(".ig-img").each(function () {
      var oneheight = $(this).innerHeight();
      $(this).innerWidth(oneheight);

  });
}



$(document).ready(function () {
  igresize();
  slickCarousel();
  $(".video-four-square").hover( hoverVideo, hideVideo );
  bgTransparentContainer();
});
$(window).resize(function () {
  igresize();
  slickCarousel();
  bgTransparentContainer();
});

$(window).load(function () {
  slickCarousel();
  bgTransparentContainer();
});


function hoverVideo() {  
    $('video', this).get(0).play(); 

}

function hideVideo() {
    $('video', this).get(0).pause(); 
}


document.addEventListener("DOMContentLoaded", function() {
  // Banner Video
  var banner_video_url = "https://wp-media.camdenmarket.com/wp-content/uploads/2023/05/23140223/discover-camden-market-mobile-rf-24.mp4#t=0.1"; // Mobile
  var banner_poster_url = "https://wp-media.camdenmarket.com/wp-content/uploads/2023/05/23141148/discover-camden-market-mobile-rf-24.webp"; // Mobile
  if ( $(window).outerWidth() > 991 ) {
      banner_video_url = "https://wp-media.camdenmarket.com/wp-content/uploads/2023/05/23140217/discover-camden-market-dekstop-rf-24.mp4#t=0.1"; // Desktop
      banner_poster_url = "https://wp-media.camdenmarket.com/wp-content/uploads/2023/05/23141146/discover-camden-market-dekstop-rf-24.webp"; // Desktop
  }
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          video.target.poster = banner_poster_url;

          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = banner_video_url;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).on("click", function (event) {
  if ($(".search-input--container").hasClass("active")) {
    if ($(event.target).closest("#mega-menu-full").length === 0 && $(event.target).closest("#mega-menu-full-dropdown").length === 0) {
      searchContainerClose();
      searchContainerCloseMenuNav();
    }
  }
});